const keys = {
    user: "USER",
    access_token: "ACCESS_TOKEN",
    user_id: "USER_ID"
};

const GENERAL_ERROR = "Something went wrong! Please try again later."

export { keys, GENERAL_ERROR }